import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintPlanningNoteViewProps } from "./Params"

export function PrintPlanningNoteView({ note }: PrintPlanningNoteViewProps) {
  const app = GetApp();
  const tn = app.getT("NoteView_note");

  return (
    <BlockRow className="print-planning-note">
      <BlockField label={tn("planning_date")} className="block-field-150">{note.date}</BlockField>
      <BlockField label={tn("planning_title")} className="block-field-300">{note.title}</BlockField>
      <BlockField label={tn("planning_note")} className="">{note.note}</BlockField>
    </BlockRow>
  );
}
